import { FormattedMessage } from 'react-intl';

import { ReportButton } from '@xing-com/crate-entity-pages-common';
import { useEditContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';

import { HELP_CENTER_URL, PROMOTE_PAGE_URL } from '../../../utils/urls';

import * as Styled from './list.styles';

type Props = {
  closePopUp: () => void;
  sharePage: () => void;
};
export const List: React.FC<Props> = ({ sharePage, closePopUp }) => {
  const { isEditing } = useEditContext();
  const { showError } = useErrorContext();
  const { pageContext, isSubpage } = usePageContext();

  const headerModuleCta = pageContext.headerModuleCta;
  const isCompanyPage = pageContext.isCompanyPage;

  return (
    <>
      <Styled.MoreMenuTitle noMargin size="small">
        <FormattedMessage id="EP_CHOOSE_ACTION" />
      </Styled.MoreMenuTitle>
      <span data-testid="HEADER_MORE_ACTIONS_LIST">
        <Styled.ListWrapper>
          <Styled.ListItem onClick={() => sharePage()} role="menuitem">
            <span data-testid="SHARE_PAGE">
              <Styled.Link size="small">
                <FormattedMessage id="EP_SHARE_PAGE" />
              </Styled.Link>
            </span>
          </Styled.ListItem>
          {!pageContext.isEditor ? (
            <Styled.ListItem role="menuitem">
              <span data-testid="REPORT_PAGE">
                <ReportButton
                  authorUrn={pageContext.globalId}
                  targetUrn={pageContext.globalId}
                  onSuccess={closePopUp}
                  onError={() =>
                    showError({ message: 'EP_GENERIC_FEEDBACK_ERROR' })
                  }
                >
                  <Styled.Link size="small">
                    <FormattedMessage id="EP_REPORT_PAGE" />
                  </Styled.Link>
                </ReportButton>
              </span>
            </Styled.ListItem>
          ) : null}
          {isEditing ? (
            <>
              {isCompanyPage ? (
                <Styled.ListItem
                  onClick={() =>
                    window.open(
                      PROMOTE_PAGE_URL(pageContext.globalId),
                      '_blank'
                    )
                  }
                >
                  <span data-testid="EP_PROMOTE_PAGE">
                    <Styled.Link size="small">
                      <FormattedMessage id="EP_PROMOTE_PAGE" />
                    </Styled.Link>
                  </span>
                </Styled.ListItem>
              ) : null}
              {!isSubpage && headerModuleCta === 'follow' ? (
                <>
                  {isCompanyPage ? (
                    <Styled.ListItem
                      onClick={() => window.open(`/brandmanager/`, '_blank')}
                    >
                      <span data-testid="ADMINISTRATE_PAGE">
                        <Styled.Link size="small">
                          <FormattedMessage id="EP_ADMINISTRATE_PAGE" />
                        </Styled.Link>
                      </span>
                    </Styled.ListItem>
                  ) : null}
                  <Styled.ListItem
                    onClick={() => window.open(HELP_CENTER_URL, '_blank')}
                  >
                    <span data-testid="HELP_CENTER">
                      <Styled.Link size="small">
                        <FormattedMessage id="EP_HELP_CENTER" />
                      </Styled.Link>
                    </span>
                  </Styled.ListItem>
                </>
              ) : null}
            </>
          ) : null}
        </Styled.ListWrapper>
      </span>
    </>
  );
};
